import { render, staticRenderFns } from "./TransMatchingFileuploades.vue?vue&type=template&id=7852b42c&scoped=true"
import script from "./TransMatchingFileuploades.vue?vue&type=script&lang=js"
export * from "./TransMatchingFileuploades.vue?vue&type=script&lang=js"
import style0 from "./TransMatchingFileuploades.vue?vue&type=style&index=0&id=7852b42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7852b42c",
  null
  
)

export default component.exports